<template>
    <v-card>
        <!-- <v-card-title primary-title> -->
            <v-toolbar flat color="white">
            <div>
                <h3 class="headline mb-0">Schedules</h3>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="show = !show">
                <v-icon>{{ show ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
            </v-btn>
            </v-toolbar>
        <!-- </v-card-title> -->

          <v-card-text v-show="show">
              <v-form v-model="valid" v-if="schedules" @submit.prevent>
              <v-layout wrap mb-4 v-for="(docSched) in schedules" :key="docSched.id">
                <v-flex xs3>
                  <v-subheader>{{docSched.docType.name}}</v-subheader>
                </v-flex>
                <v-flex xs1>
                <v-switch inset v-model="docSched.enabled" hide-details @change="toggle(docSched.enabled, docSched.id)"></v-switch>
                </v-flex>
                <v-flex xs2 mr-1 v-if="docSched.enabled">
                <v-text-field
                label="Polling Time (HH:MM)"
                  v-model="docSched.polltime"
                  @input="change"
                  :rules="[rules.required, rules.formatHour]"
                  :hint="timezone(docSched.polltime)"
                  persistent-hint
                ></v-text-field>
                </v-flex>
                <v-flex xs2 ml-1 v-if="docSched.enabled">
                  <v-select v-model="docSched.interval" :items="intervals"
                        :rules="[rules.required]" @change="change"
                        :disabled="intervalDisabled"
                        hint="Polling Interval"
                        persistent-hint
                        item-text="text" item-value="value">
                  </v-select>
                </v-flex>
                <v-flex xs2 ml-1 v-if="showPollDetails(system, docSched)">
                  Last Run: {{formatTime(docSched.driver.schedule.lastRunTime)}} - Next Run: {{formatTime(docSched.driver.schedule.nextRunTime)}}
                  <v-btn v-if="!docSched.driver.polling" @click="repoll(docSched.driver)">Poll Now</v-btn>
                  <p v-if="docSched.driver.polling"></p>
                  <span class="subtitle" v-if="docSched.driver.polling">Polling Now</span>
                  <v-btn text icon color="grey lighten-1"
                    :loading="refreshingDriverSchedules"
                    @click="refreshDriverSchedules(docSched.driver)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="system.supportsRealtime">
                <v-flex xs3>
                  <v-subheader>Realtime Data</v-subheader>
                </v-flex>
                <v-flex xs1>
                <v-switch inset v-model="system.rtEnabled" hide-details @change="change"></v-switch>
                </v-flex>
                <v-flex xs2 v-if="system.rtEnabled" mr-2>
                  <v-text-field
                    label="Polling Interval (milliseconds)"
                    v-model="system.rtPollIntervalMs"
                    :rules="[rules.formatMilliSeconds]"
                    hint="Leave blank to default to 10000 ms (10 s)"
                    placeholder="10000"
                    @input="change">
                  </v-text-field>
              </v-flex>
              <!--
                <v-flex xs2 ml-1 v-if="system.rtEnabled">
                  <v-text-field
                    label="Detail Polling Interval (seconds)"
                    v-model="system.rtDetailRefreshIntervalSeconds"
                    :rules="[rules.formatSeconds]"
                    placeholder="60"
                    @input="change">
                  </v-text-field>
              </v-flex>
              -->
              </v-layout>
              </v-form>
          </v-card-text>
        <v-card-actions v-show="show">
            <v-btn text color="orange" :disabled="!changed" @click="reset">Reset</v-btn>
            <v-btn text color="orange" :disabled="!changed || !valid" @click="apply">Save</v-btn>
        </v-card-actions>
       </v-card>
</template>
<script>
import Vue from "vue";
import SchedulePicker from "./SchedulePicker.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";
export default {
  components: {
    "schedule-picker": SchedulePicker
  },
  computed: {
    ...mapGetters('user', {
           orgTimeZone: 'getOrgTimezone',
           ccoTimeZone: 'getCcoTimezone'
        })
  },
  data() {
    return {
      refreshingDriverSchedules: false,
      show: false,
      changed: false,
      valid: true,
      enabledSchedules: [],
      disabledSchedules: [],
      intervalDisabled: this.disableInterval,
      rules: {
        required: value => !!value || 'Required.',
        formatHour: value => /^(2[0-3]|[01][0-9]):([0-5][0-9])$/.test(value) || 'Invalid format (should be HH:MM)',
        formatSeconds: value => !value || (value > 0) || 'Invalid format (should be a number greater than 0)',
        formatMilliSeconds: value => !value || (value >= 10) || 'Invalid format (should be >= 10)'
      },
      intervals: [
        {text: 'Daily', value: "86400"},
        {text: '12 hours', value: "43200"},
        {text: '10 hours', value: "36000"},
        {text: '8 hours', value: "28800"},
        {text: '6 hours', value: "21600"},
        {text: '4 hours', value: "14400"},
        {text: '2 hours', value: "7200"},
        {text: '1 hour', value: "3600"},
        {text: '30 minutes', value: "1800"},
        {text: '10 minutes', value: "600"},
        {text: '5 minutes', value: "300"},
        {text: '1 minutes', value: "60"}
      ]
    };
  },
  props: {
    system: Object,
    schedules: Array,
    disableInterval: Boolean
  },
  created() {
    this.enabledSchedules = _.map(_.filter(this.schedules, {enabled: true}), 'id')
  },
  methods: {
    async reset() {
      await this.$store.dispatch("systems/resetActiveSystemSchedules");
      this.changed = false
    },
    async apply() {
      try {
        // this.system.rtDetailRefreshIntervalSeconds = this.system.rtDetailRefreshIntervalSeconds || 60
        await this.$store.dispatch("systems/saveActiveSystemSchedules");
        this.enabledSchedules = _.map(_.filter(this.schedules, {enabled: true}), 'id')
        this.changed = false
      } catch (e) {
        console.error(e);
      }
    },
    change() {
      this.changed = true
    },
    toggle(val, id) {
      this.changed = true
    },
    formatTime(time) {
      if (!time) {
        return ''
      }
      return moment(time)
    },
    convertTz(polltime, srcTz, tgtTz) {
      var formattedSrcTz = moment().tz(srcTz).format("YYYY-MM-DD");
      var refMomentTz = moment.tz(formattedSrcTz + ' ' + polltime, "YYYY-MM-DD HH:mm", srcTz);

      return refMomentTz.tz(tgtTz).format("HH:mm")
    },
    timezone(polltime) {
      if (!this.system.isCloudSystem || !this.ccoTimeZone || (this.ccoTimeZone === this.orgTimeZone)) {
        return this.orgTimeZone
      }
      return this.orgTimeZone + " (" + this.convertTz(polltime, this.orgTimeZone, this.ccoTimeZone) + ' ' + this.ccoTimeZone + ')'
    },
    async repoll(driver) {
      console.dir(driver)
      const res = await this.$store.dispatch("systems/repoll", {
        collectorId: driver.collector,
        collectorName: driver.clazz,
        systemId: this.system.id });
      if (!res) {
        alert('Poll requested')
      } else {
        alert(res)
      }
    },
    async refreshDriverSchedules(driver) {
      this.refreshingDriverSchedules = true
      await this.$store.dispatch("systems/getSystemSchedules", {id: this.system.id, sysConfigs: this.system.configs, forceDriverRefresh: true, isCloudSystem: this.system.isCloudSystem});
      this.refreshingDriverSchedules = false
    },
    showPollDetails(system, docSched) {

      return system.pollEnabled && docSched.enabled && this.enabledSchedules.includes(docSched.id)
      && docSched.driver && docSched.driver.schedule
    }
  }
};
</script>
